import MtaAccessNotification from './access-notification';
import { Autorenew } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { MtaBlockedReason } from '../../../types';

interface IMtaJourneyAccess {
	permitAccess: boolean;
	handleClick: () => void;
	showAccessMessage: boolean;
	reasonForBlockedAccess: MtaBlockedReason;
}

/**
 * Separation of concerns for MTA Journey Access - button and notification
 * @param permitAccess - connects to the disabled state of the button
 * @param handleClick - passed to the Button's `onClick` - likely to be a straightforward navigation
 * @param showAccessMessage - visibility of the message explaining why access is blocked
 * @param reasonForBlockedAccess - the reason for blocked access - this will trigger the appropriate content
 */
const MtaJourneyAccess = ({
	permitAccess,
	handleClick,
	showAccessMessage,
	reasonForBlockedAccess,
}: IMtaJourneyAccess) => {
	return (
		<>
			<Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'end' } }}>
				<Button
					startIcon={<Autorenew />}
					size='large'
					color='primary'
					variant='contained'
					sx={{ width: { xs: '100%', md: 'auto' } }}
					onClick={handleClick}
					disabled={!permitAccess}
				>
					Make a Change
				</Button>
			</Box>
			{showAccessMessage && (
				<Box sx={{ my: '1rem' }}>
					<MtaAccessNotification reasonBlocked={reasonForBlockedAccess} />
				</Box>
			)}
		</>
	);
};

export default MtaJourneyAccess;
